<!-- ===== REFONTE : écran des confirmations d'une activité ===== -->
<div class="w-full p-10 create-activity-one cst-content-ctnr">
  <div class="cf-page">
    <app-breadcrumb [items]="breadCrumbItems"></app-breadcrumb>

    <!-- Bandeaux erreur / succès -->
    <div class="cf-alerte" role="alert" *ngIf="erreur">
      <span>{{ erreur }}</span>
      <button
        type="button"
        class="cf-alerte__fermer"
        aria-label="Fermer"
        (click)="erreur = null"
      >
        ×
      </button>
    </div>
    <div class="cf-alerte cf-alerte--succes" role="status" *ngIf="succes">
      <span>{{ succes }}</span>
      <button
        type="button"
        class="cf-alerte__fermer"
        aria-label="Fermer"
        (click)="succes = null"
      >
        ×
      </button>
    </div>

    <div class="cf-carte" *ngIf="activity as activite">
      <!-- ===== En-tête de l'activité ===== -->
      <div class="cf-entete">
        <div class="cf-entete__texte">
          <div class="cf-tags">
            <span class="cf-tag cf-tag--type">{{ libelleType }}</span>
            <span class="cf-tag">
              <!-- ===== AJOUT : drapeau devant le pays ===== -->
              <svg
                class="cf-drapeau"
                viewBox="0 0 30 20"
                aria-hidden="true"
                [ngSwitch]="codePays"
              >
                <g *ngSwitchCase="'bj'">
                  <rect width="30" height="10" fill="#fcd116" />
                  <rect y="10" width="30" height="10" fill="#e8112d" />
                  <rect width="12" height="20" fill="#008751" />
                </g>
                <g *ngSwitchDefault>
                  <rect width="10" height="20" fill="#00853f" />
                  <rect x="10" width="10" height="20" fill="#fdef42" />
                  <rect x="20" width="10" height="20" fill="#e31b23" />
                  <polygon
                    points="15,6.2 16.1,9.4 19.4,9.4 16.7,11.4 17.7,14.6 15,12.6 12.3,14.6 13.3,11.4 10.6,9.4 13.9,9.4"
                    fill="#00853f"
                  />
                </g>
              </svg>
              {{ libellePays }}
            </span>
            <span
              class="cf-tag"
              [ngClass]="estFermee ? 'cf-tag--fermee' : 'cf-tag--ouverte'"
            >
              {{ estFermee ? "Fermée" : "Ouverte" }}
            </span>
          </div>
          <h2 class="cf-titre">{{ activite["nomActivity"] }}</h2>
          <div class="cf-infos">
            <span *ngIf="activite['openDate']">
              {{ activite["openDate"] | date: "d MMM y" : "" : "fr" }}
              <ng-container
                *ngIf="
                  activite['closeDate'] &&
                  activite['closeDate'] !== activite['openDate']
                "
              >
                → {{ activite["closeDate"] | date: "d MMM y" : "" : "fr" }}
              </ng-container>
            </span>
            <span *ngIf="heure">{{ heure }}</span>
            <span *ngIf="activite['adresse']">{{ activite["adresse"] }}</span>
          </div>
          <p class="cf-description" *ngIf="activite['description']">
            {{ activite["description"] }}
          </p>
        </div>
        <button
          type="button"
          class="cf-btn cf-btn--secondaire"
          (click)="exportTable()"
          [disabled]="!participantsFiltres.length"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
          </svg>
          Exporter la liste filtrée
        </button>
      </div>

      <!-- ===== Compteurs ===== -->
      <div class="cf-compteurs">
        <div class="cf-compteur">
          <span class="cf-compteur__libelle">Invités ou inscrits</span>
          <span class="cf-compteur__nombre">{{ nbInvites }}</span>
          <span class="cf-barre"
            ><i class="cf-barre--total" style="width: 100%"></i
          ></span>
        </div>
        <div class="cf-compteur">
          <span class="cf-compteur__libelle">Ont confirmé</span>
          <span class="cf-compteur__nombre">
            {{ nbConfirmes }}
            <small class="cf-pct cf-pct--confirme"
              >{{ pourcentage(nbConfirmes) }} %</small
            >
          </span>
          <span class="cf-barre"
            ><i
              class="cf-barre--confirme"
              [style.width.%]="pourcentage(nbConfirmes)"
            ></i
          ></span>
        </div>
        <div class="cf-compteur">
          <span class="cf-compteur__libelle">Présents</span>
          <span class="cf-compteur__nombre">
            {{ nbPresents }}
            <small class="cf-pct cf-pct--present"
              >{{ pourcentage(nbPresents) }} %</small
            >
          </span>
          <span class="cf-barre"
            ><i
              class="cf-barre--present"
              [style.width.%]="pourcentage(nbPresents)"
            ></i
          ></span>
        </div>
        <div class="cf-compteur">
          <span class="cf-compteur__libelle">Sans réponse</span>
          <span class="cf-compteur__nombre">
            {{ nbSansReponse }}
            <small class="cf-pct cf-pct--attente"
              >{{ pourcentage(nbSansReponse) }} %</small
            >
          </span>
          <span class="cf-barre"
            ><i
              class="cf-barre--attente"
              [style.width.%]="pourcentage(nbSansReponse)"
            ></i
          ></span>
        </div>
      </div>

      <!-- ===== Aucun participant ===== -->
      <p class="cf-vide" *ngIf="!chargement && !participants.length">
        Cette activité n'a pas encore de participant.
      </p>

      <ng-container *ngIf="participants.length">
        <!-- ===== Filtres et recherche ===== -->
        <div class="cf-outils">
          <div class="cf-filtres" role="group" aria-label="Filtrer par statut">
            <button
              type="button"
              class="cf-filtre"
              [class.cf-filtre--actif]="filtre === 'tous'"
              (click)="choisirFiltre('tous')"
            >
              Tous <b>{{ nbInvites }}</b>
            </button>
            <button
              type="button"
              class="cf-filtre"
              [class.cf-filtre--actif]="filtre === 'confirmes'"
              (click)="choisirFiltre('confirmes')"
            >
              Confirmés <b>{{ nbConfirmes }}</b>
            </button>
            <button
              type="button"
              class="cf-filtre"
              [class.cf-filtre--actif]="filtre === 'presents'"
              (click)="choisirFiltre('presents')"
            >
              Présents <b>{{ nbPresents }}</b>
            </button>
            <button
              type="button"
              class="cf-filtre"
              [class.cf-filtre--actif]="filtre === 'sansReponse'"
              (click)="choisirFiltre('sansReponse')"
            >
              Sans réponse <b>{{ nbSansReponse }}</b>
            </button>
          </div>
          <label class="cf-recherche">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              aria-hidden="true"
            >
              <circle cx="11" cy="11" r="7" />
              <path d="M20 20l-3.5-3.5" />
            </svg>
            <input
              type="text"
              [formControl]="searchCtrl"
              placeholder="Nom, email, téléphone, identifiant…"
              aria-label="Rechercher un participant"
            />
          </label>
        </div>

        <!-- ===== Tableau ===== -->
        <div class="cf-tableau">
          <table>
            <thead>
              <tr>
                <th>Participant</th>
                <th>Identifiant</th>
                <th>Téléphone</th>
                <th>Statut</th>
                <th class="cf-droite">Présence</th>
                <th class="cf-droite" *ngIf="isAdmin">Retirer</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of pageCourante">
                <td class="cf-qui">
                  <b>{{ (nomComplet(p) | titlecase) || "—" }}</b>
                  <span
                    class="cf-manquant"
                    *ngIf="nomComplet(p) && !p.lastname?.trim()"
                    >Nom de famille manquant</span
                  >
                  <span>{{ p.email }}</span>
                </td>
                <td class="cf-id">{{ p.id }}</td>
                <td class="cf-tel">
                  <span *ngIf="telephoneDe(p); else telVide">{{
                    telephoneDe(p)
                  }}</span>
                  <ng-template #telVide
                    ><span class="cf-gris">—</span></ng-template
                  >
                  <button
                    *ngIf="isAdmin"
                    type="button"
                    class="cf-lien"
                    (click)="ouvrirTelephone(p)"
                    [attr.aria-label]="'Modifier le numéro de ' + nomComplet(p)"
                  >
                    {{ telephoneDe(p) ? "Modifier" : "Ajouter" }}
                  </button>
                </td>
                <td>
                  <span class="cf-statut" [ngClass]="statut(p).classe"
                    ><i></i>{{ statut(p).libelle }}</span
                  >
                </td>
                <td class="cf-droite">
                  <span
                    class="cf-present"
                    *ngIf="p.present; else boutonPresence"
                    >✓ Présent</span
                  >
                  <ng-template #boutonPresence>
                    <button
                      type="button"
                      class="cf-btn cf-btn--petit"
                      (click)="ouvrirPresence(p)"
                    >
                      Marquer présent
                    </button>
                  </ng-template>
                </td>
                <td class="cf-droite" *ngIf="isAdmin">
                  <button
                    type="button"
                    class="cf-icone cf-icone--danger"
                    title="Retirer de l'activité"
                    [attr.aria-label]="
                      'Retirer ' + nomComplet(p) + ' de l\'activité'
                    "
                    (click)="ouvrirSuppression(p)"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"
                      />
                    </svg>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!pageCourante.length">
                <td [attr.colspan]="isAdmin ? 6 : 5" class="cf-vide">
                  Aucun participant ne correspond à ta recherche.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ===== Pagination ===== -->
        <div class="cf-pied">
          <span
            >Lignes {{ premiereLigne }} à {{ derniereLigne }} sur
            {{ participantsFiltres.length }}</span
          >
          <div class="cf-pagination">
            <button
              type="button"
              class="cf-btn cf-btn--secondaire cf-btn--petit"
              [disabled]="currentPage === 1"
              (click)="previousPage()"
            >
              Précédent
            </button>
            <span>Page {{ currentPage }} sur {{ totalPages }}</span>
            <button
              type="button"
              class="cf-btn cf-btn--secondaire cf-btn--petit"
              [disabled]="currentPage === totalPages"
              (click)="nextPage()"
            >
              Suivant
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- ===== Popup : confirmer la présence ===== -->
  <div
    class="cf-overlay"
    *ngIf="participantPresence as p"
    (click)="fermerPresence()"
  >
    <div
      class="cf-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cf-presence-titre"
      (click)="$event.stopPropagation()"
    >
      <div class="cf-dialog__corps">
        <span class="cf-dialog__icone cf-dialog__icone--succes">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </span>
        <h3 id="cf-presence-titre">Confirmer la présence ?</h3>
        <p>
          <b>{{ nomComplet(p) | titlecase }}</b> sera marqué(e) présent(e) à «
          {{ activity?.["nomActivity"] }} ». Une présence validée ne peut pas
          être annulée ici.
        </p>
      </div>
      <div class="cf-dialog__pied">
        <button
          type="button"
          class="cf-btn cf-btn--secondaire"
          (click)="fermerPresence()"
          [disabled]="presenceEnCours"
        >
          Annuler
        </button>
        <button
          type="button"
          class="cf-btn cf-btn--succes"
          (click)="confirmerPresence()"
          [disabled]="presenceEnCours"
        >
          {{ presenceEnCours ? "Enregistrement…" : "Confirmer la présence" }}
        </button>
      </div>
    </div>
  </div>

  <!-- ===== Popup : retirer un participant (admin) ===== -->
  <div
    class="cf-overlay"
    *ngIf="participantToDelete as p"
    (click)="closeDeleteModal()"
  >
    <div
      class="cf-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cf-suppr-titre"
      (click)="$event.stopPropagation()"
    >
      <div class="cf-dialog__corps">
        <span class="cf-dialog__icone cf-dialog__icone--danger">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />
          </svg>
        </span>
        <h3 id="cf-suppr-titre">Retirer ce participant ?</h3>
        <p>
          <b>{{ nomComplet(p) | titlecase }}</b> sera retiré(e) de cette
          activité. Cette action est irréversible.
        </p>
      </div>
      <div class="cf-dialog__pied">
        <button
          type="button"
          class="cf-btn cf-btn--secondaire"
          (click)="closeDeleteModal()"
          [disabled]="suppressionEnCours"
        >
          Annuler
        </button>
        <button
          type="button"
          class="cf-btn cf-btn--danger"
          (click)="deleteParticipant()"
          [disabled]="suppressionEnCours"
        >
          {{ suppressionEnCours ? "Suppression…" : "Retirer" }}
        </button>
      </div>
    </div>
  </div>

  <!-- ===== Popup : téléphone (admin), saisie puis confirmation ===== -->
  <div
    class="cf-overlay"
    *ngIf="etapeTelephone && participantToEditPhone as p"
    (click)="fermerTelephone()"
  >
    <div
      class="cf-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cf-tel-titre"
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngIf="etapeTelephone === 'saisie'; else confirmationTel">
        <div class="cf-dialog__corps">
          <h3 id="cf-tel-titre">
            {{ telephoneDe(p) ? "Modifier le numéro" : "Ajouter un numéro" }}
          </h3>
          <p>
            <b>{{ nomComplet(p) | titlecase }}</b>
          </p>
          <label class="cf-champ">
            <span>{{
              estInformelle ? "Numéro Wave" : "Numéro de téléphone"
            }}</span>
            <input
              type="tel"
              [(ngModel)]="newPhoneNumber"
              (ngModelChange)="numeroModifie()"
              [placeholder]="
                estInformelle
                  ? 'Numéro Wave, ex : 770000000'
                  : 'Ex : +221 77 000 00 00'
              "
              (keydown.enter)="verifierTelephone()"
            />
          </label>
          <!-- ===== AJOUT : numéro refusé ou vérification impossible ===== -->
          <p class="cf-champ__erreur" role="alert" *ngIf="erreurTelephone">
            {{ erreurTelephone }}
          </p>
        </div>
        <div class="cf-dialog__pied">
          <button
            type="button"
            class="cf-btn cf-btn--secondaire"
            (click)="fermerTelephone()"
          >
            Annuler
          </button>
          <button
            type="button"
            class="cf-btn cf-btn--primaire"
            [disabled]="
              !newPhoneNumber.trim() ||
              verificationTelephone ||
              !!erreurTelephone
            "
            (click)="verifierTelephone()"
          >
            {{ verificationTelephone ? "Vérification…" : "Continuer" }}
          </button>
        </div>
      </ng-container>
      <ng-template #confirmationTel>
        <div class="cf-dialog__corps">
          <h3 id="cf-tel-titre">Confirmer le nouveau numéro ?</h3>
          <p>
            Le numéro de <b>{{ nomComplet(p) | titlecase }}</b>
            <ng-container *ngIf="telephoneDe(p)">
              passera de <b>{{ telephoneDe(p) }}</b> à</ng-container
            >
            <ng-container *ngIf="!telephoneDe(p)"> sera</ng-container>
            <b>{{ newPhoneNumber.trim() }}</b
            >.
          </p>
        </div>
        <div class="cf-dialog__pied">
          <button
            type="button"
            class="cf-btn cf-btn--secondaire"
            (click)="etapeTelephone = 'saisie'"
            [disabled]="telephoneEnCours"
          >
            Retour
          </button>
          <button
            type="button"
            class="cf-btn cf-btn--primaire"
            (click)="confirmUpdatePhone()"
            [disabled]="telephoneEnCours"
          >
            {{ telephoneEnCours ? "Enregistrement…" : "Confirmer" }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<!-- ===== FIN REFONTE ===== -->
